// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from 'axios'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import messages from '../localizations/locales'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA2KXx4lNcdCzwoD3jj-K5fKkFWS1dETd4',
    libraries: 'places'
  }
})

Vue.use(VueI18n)
Vue.use(Vuex)

Vue.config.productionTip = true

axios.defaults.baseURL = '/api'

Vue.prototype.$http = axios
const store = new Vuex.Store({
  state: {
    bounds: null,
    connected: true,
    error: null,
    currentPosition: false,
    initPosition: null,
    loading: true,
    positionWithinBounds: false,
    selectedMarker: null,
    showLegalModal: false
  },
  mutations: {
    bounds: (state, bounds) => { state.bounds = bounds },
    connected: (state, coords) => { state.connected = coords },
    error: (state, coords) => { state.error = coords },
    initPosition: (state, coords) => { state.initPosition = coords },
    loading: (state, isLoading) => { state.loading = isLoading },
    currentPosition: (state, coords) => { state.currentPosition = coords },
    positionWithinBounds: (state, bool) => { state.positionWithinBounds = bool },
    showLegalModal: (state, bool) => { state.showLegalModal = bool },
    selectedMarker: (state, marker) => { state.selectedMarker = marker }
  }
})

const i18n = new VueI18n({
  locale: 'en',
  messages,
  fallbackLocale: 'en'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js